<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    :first_btn="step == 1 ? $t('Suppliers.Verify') : $t('Common.Close')"
    :loading="loading"
    :title="step == 1 ? $t('Tenders.CheckFromEDPROU') : `${$t('Suppliers.Counterparty')} ${value}`"
    width="500px"
    :without_second_btn="step == 2"
    @apply="checkFromEDPROU"
    @close="setState(false)">
    <template #activator-btn>
      <TooltipedBtn
        data-qa="btn-check-edrpou"
        :disabled="disabled"
        icon="yc"
        :loading="disabled"
        :small-btn="true"
        :text="$t('Tenders.CheckFromEDPROU')"
        :texted="$vuetify.breakpoint.lgAndUp"
        @click="setState(true)"/>
    </template>
    <template #card-text>
      <sFormItem
        v-if="step == 1"
        :error="error"
        :label="$t('Suppliers.EDRPOUCode')"
        :required="true">
        <sInput
          clearable
          data-qa="check-edrpou-input"
          :max-length="10"
          :placeholder="$t('Suppliers.InputEDRPOUPlaceholder')"
          :value.sync="value"/>
      </sFormItem>
      <div v-else>
        <div class="mb-4">
          {{ $t('Suppliers.OpenHref') }}:
        </div>
        <a
          :href="href"
          target="_blank">{{ href }}</a>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

export default {
  name: 'CheckEDRPOU',
  data() {
    return {
      dialog: false,
      loading: false,
      error: null,
      value: '',
      step: 1,
    }
  },
  methods: {
    /**
     * Откріть проверку по ЄДРПОУ
     */
    async checkFromEDPROU() {
      this.error = null
      if (this.step == 1) {
        if (!this.value?.trim()) {
          this.error = this.$t('Validate.Required')
          return
        }
        this.step = 2
      } else {
        this.setState(false)
        this.step = 1
      }
    },
    setState(state) {
      if (state) {
        this.step = 1
        this.value = ''
      }
      this.dialog = state
    },
  },
  computed: {
    href() {
      return `https://youcontrol.com.ua/search/?q=${this.value}`
    },
  },
  components: {
    TooltipedBtn,
    DialogTemplateToolkit,
  },
  created() {},
  props: {
    disabled: {
      type: Boolean
    }
  },
}
</script>
<style scoped lang="scss">
</style>
